import { logger } from "./logger";

export const getApiBaseUrl = () => process.env.REACT_APP_API_BASE_URL || "http://localhost:8000/api/v1";

const VAULT_SESSION_STORAGE_KEY = "vaultMigrationSessionId";

const createClientId = () => {
  if (typeof crypto !== "undefined" && typeof crypto.randomUUID === "function") {
    return crypto.randomUUID();
  }
  return `${Date.now()}-${Math.random().toString(16).slice(2)}`;
};

export const getVaultMigrationSessionId = () => {
  try {
    const existing = sessionStorage.getItem(VAULT_SESSION_STORAGE_KEY);
    if (existing && existing.trim()) {
      return existing.trim();
    }
    const generated = createClientId();
    sessionStorage.setItem(VAULT_SESSION_STORAGE_KEY, generated);
    return generated;
  } catch {
    return createClientId();
  }
};

const toHeaderObject = (headers) => {
  if (!headers) {
    return {};
  }
  if (headers instanceof Headers) {
    return Object.fromEntries(headers.entries());
  }
  return { ...headers };
};

export const fetchWithTimeout = async (url, options = {}, timeoutMs = 45000) => {
  const controller = new AbortController();
  const timer = setTimeout(() => controller.abort(), timeoutMs);

  try {
    const requestOptions = { ...options };
    const isVaultMigrationRequest = String(url || "").includes("/vault-migration/");
    if (isVaultMigrationRequest) {
      const headers = toHeaderObject(requestOptions.headers);
      if (!headers["x-session-id"]) {
        headers["x-session-id"] = getVaultMigrationSessionId();
      }
      requestOptions.headers = headers;
      // Send httpOnly cookie for authentication
      requestOptions.credentials = "include";
    }

    return await fetch(url, { ...requestOptions, signal: controller.signal });
  } catch (error) {
    logger.error("vault_fetch_with_timeout_failed", { url, timeoutMs, error: String(error?.message || error) });
    const errorName = String(error?.name || "").toLowerCase();
    const errorMessage = String(error?.message || "").toLowerCase();
    const aborted = errorName === "aborterror" || errorMessage.includes("aborted") || errorMessage.includes("signal is aborted");
    if (aborted) {
      const timeoutSeconds = Math.max(1, Math.round(timeoutMs / 1000));
      throw new Error(`Request timed out after ${timeoutSeconds}s. Please retry.`);
    }
    throw error;
  } finally {
    clearTimeout(timer);
  }
};
